import React, { useEffect } from "react";
import "./toast.css";
import useTimeout from "../../utils/hooks/useTimeout";
import useToast, { TOAST_TYPES } from "../../utils/hooks/useToast";
import { ICONS } from "../../utils/constants/ICONS";
import useErrorService from "../../utils/hooks/useErrorService";

export default function Toast({ toast }) {
  const [, removeToast] = useToast();
  const [reset, , modify] = useTimeout(
    () => removeToast(toast.id),
    toast.duration
  );
  const [sendConsoleLogEmail] = useErrorService("Deal Portal", console.everything);

  useEffect(() => reset(), [reset]);

  return (
    <div className="toast-container" data-type={toast.type}>
      <div className="toast-icon"></div>
      <span
        className="toast-content"
        title="Click to keep open"
        onClick={() => modify(() => removeToast(toast.id), 1000000)}
      >
        {toast.message}
      </span>
      <div className="toast-actions">
        <div
          className="toast-action toast-close"
          title="Close"
          onClick={() => removeToast(toast.id)}
        >
          {ICONS.X}
        </div>
        {toast.type === TOAST_TYPES.ERROR && (
          <div
            className="toast-action toast-send-email"
            title="Send log to dev"
            onClick={sendConsoleLogEmail}
          >
            {ICONS.SEND_MAIL}
          </div>
        )}
      </div>
    </div>
  );
}